

export const formValidation = (event, callback = true) => {
    event.preventDefault();
    event.target.classList.add('was-validated');
    if (event.target.checkValidity() === false) {
        event.stopPropagation();
        return false;
    }else{
        event.target.classList.remove('was-validated');
        return callback();
    }
}